<template>
    <div class="cost clearfix">
        <Form :model="formData" :labelWidth="150" ref="form">
            <Col span="24">
                <FormItem
                    :label="
                        $t('fbb.headlogistics.cost_china', {
                            defaultValue: '中国段费用',
                        })
                    "
                    prop="china_estimate_cost"
                    :rules="required"
                >
                    <InputNumber
                        class="width-75per"
                        :min="0"
                        v-model="formData.china_estimate_cost"
                    ></InputNumber>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem
                    :label="
                        $t('fbb.headlogistics.cost_sea', {
                            defaultValue: '海运费',
                        })
                    "
                    prop="ocean_freight_estimate"
                    :rules="required"
                >
                    <InputNumber
                        class="width-75per"
                        :min="0"
                        v-model="formData.ocean_freight_estimate"
                    ></InputNumber>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem
                    :label="
                        $t('fbb.headlogistics.destination_cost', {
                            defaultValue: '目的国费用',
                        })
                    "
                    prop="destination_estimate_cost"
                    :rules="required"
                >
                    <InputNumber
                        :min="0"
                        class="width-75per"
                        v-model="formData.destination_estimate_cost"
                    ></InputNumber>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem
                    :label="
                        $t('fbb.headlogistics.tariff', {
                            defaultValue: '关税',
                        })
                    "
                    prop="tariff_estimate"
                    :rules="required"
                >
                    <InputNumber
                        class="width-75per"
                        :min="0"
                        v-model="formData.tariff_estimate"
                    ></InputNumber>
                </FormItem>
            </Col>
        </Form>
        <div class="button-container pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">确定</Button>
            <Button @click="$emit('on-close')">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { HttpUpdateLogistics, HttpSeeLogisticsOne } from "@/service/headlogistics"
export default {
    props: ["componentName", "type", "originData", "logisticsType", "isSub", "operateType", "childId"],
    data() {
        return {
            formData: {
                china_estimate_cost: null,
                ocean_freight_estimate: null,
                destination_estimate_cost: null,
                tariff_estimate: null
            },
            price: 0,
            required: [
                {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }
            ],
            loading: false
        };
    },
    created () {
        this.getCost();
    },
    methods: {
        handleTotalCost () {
            let price = 0;
            Object.keys(this.formData).map(key => {
                price += parseFloat(this.formData[key]);
            });
            this.price = price;
        },
        async getCost () {
            this.loading = true;
            await HttpSeeLogisticsOne({
                orderId: this.originData.id
            }).then(res => {
                console.log(res);
                this.formData = {
                    china_estimate_cost: res.data.chinaEstimateCost,
                    ocean_freight_estimate: res.data.oceanFreightEstimate,
                    destination_estimate_cost: res.data.destinationEstimateCost,
                    tariff_estimate: res.data.tariffEstimate
                };
                this.handleTotalCost();
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        async submit () {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            this.handleTotalCost();
            this.loading = true;
            let requestData = {
                content: {
                    ...this.formData,
                    price: this.price
                },
                headId: this.isSub ? this.childId: this.originData.id,
                isSub: this.isSub ? true : false,
                type: this.operateType,
            };
            await HttpUpdateLogistics(requestData).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-close');
                this.$emit('on-success');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        }
    }
};
</script>

<style>
</style>